<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Список транспортных средств"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-car"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Транспортные средства
        </div>
      </template>

      <v-data-table
        :headers="headers"
        :items="items"
        @click:row="row_click"
        :items-per-page="choose?5:10"
        multi-sort
        :footerProps="datatable_footer"
      >
        <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            large
            color="primary"
            class="mr-2"
            @click="show_vehicle_show_dialog(item)"
          >
            mdi-cog
          </v-icon>
        </template>
        <template v-slot:item.selected="{item}">
            <v-checkbox
              v-if="choose"
              v-model="item.selected"
              />
          </template>
        <template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.vin"
                    label="VIN"
                    @input="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.model"
                    label="Модель"
                    @input="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="form.number"
                    label="Гос.номер"
                    @input="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="form.doc.series"
                    label="Серия документа"
                    @input="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="form.doc.series"
                    label="Номер документа документа"
                    @input="load"
                  />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                    v-model="form.name"
                    label="ФИО"
                    @input="load"
                  />
                  </v-col>  
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="load"
                  >
                    Поиск
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </v-data-table>

      <v-card-actions>
        <v-row>
          <v-col cols="2" v-if="choose && multiple">
            <v-btn
          
          color="secondary"
          min-width="200"
          @click="$emit('close')"
        >
          Назад
        </v-btn>
          </v-col>
          <v-col cols="2">
            <v-btn
          color="primary"
          min-width="200"
          @click="show_vehicle_create_dialog"
        >
          Создание
        </v-btn>
          </v-col>
          <v-col cols="8" class="text-right">
        <v-btn
          v-if="choose && multiple"
          color="success"
          min-width="200"
          @click="$emit('select', items.filter(a=>a.selected))"
        >
          Выбрать
        </v-btn>
        </v-col>
        </v-row>
        
      </v-card-actions>
    </base-material-card>
    <v-dialog v-model="dialog.vehicle.show" persistent>
        <VehicleForm
          :create="dialog.vehicle.create"
          :view="dialog.vehicle.view"
          :change="dialog.vehicle.change"
          :show="dialog.vehicle.show"
          :data="dialog.vehicle.data"
          @close="vehicle_close"
        />
      </v-dialog>
  </v-container>
</template>

<script>
  import moment from 'moment'
  export default {
    name: 'DashboardDataTables',
    props: ['show','choose', 'multiple', 'vehicle'],
    data: () => ({
      datatable_footer: {
        itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', 
        pageText: 'из'
      },
      headers: [
        {
          value: 'action',
        },
        {
          text: 'Модель',
          value: 'model',
        },
        {
          text: 'VIN',
          value: 'vin',
        },
        {
          text: 'Номер',
          value: 'number',
        },
        {
          text: 'Серия СТС',
          value: 'doc.series',
        },
        {
          text: 'Номер СТС',
          value: 'doc.number',
        },
        {
          text: 'Выбран',
          value: 'selected'
        }
      ],
      items: [],
      search: undefined,
      form: {
        doc: {
          series: '',
          number: '',
        },
        name: '',
        model: '',
        number: ''
      },
      dialog: {
          vehicle: {
            show: false,
            create: false,
            change: false,
            view: false,
            data: {},
          },
        }
    }),
    watch: {
      'show': function() {
        if (this.show) {
          this.load()
        }
      }
    },
    mounted: function () {
      this.load()
    },
    methods: {
      row_click: function(item) {
        if (this.choose) {
          if (!this.multiple) {
            this.$emit('select', [item])
          }
        }
      },
      vehicle_close: function() {
        this.dialog.vehicle.show = false
        this.load()
      },
      show_vehicle_create_dialog: function () {
        this.dialog.vehicle.create = true
        this.dialog.vehicle.change = false
        this.dialog.vehicle.view = false
        this.dialog.vehicle.show = true
      },
      show_vehicle_show_dialog: function (data) {
        this.dialog.vehicle.create = false
        this.dialog.vehicle.change = false
        this.dialog.vehicle.view = true
        this.dialog.vehicle.show = true
        this.dialog.vehicle.data = data
      },
      load: function () {
        this.axios.post('/api/common/vehicle/list', this.form)
          .then(result => {
            if (!result.data.error) {
              this.items = result.data.data
            }
          })
          .catch(e => {

          })
      },
    },
  }
</script>
